export default class CharShape {
    constructor(char, size) {
        this.char = char;
        this.size = size;
        this.padding = 1;

        this.canvas = document.createElement('canvas');
        this.canvas.className = 'border border-dark';

        this.context = this.canvas.getContext('2d');
        this.canvas.width = size;
        this.canvas.height = size;
        this.context.font = size + "px serif";

        let metrics = this.context.measureText(char);
        let width = Math.abs(metrics.actualBoundingBoxLeft) + Math.abs(metrics.actualBoundingBoxRight);
        let height = Math.abs(metrics.actualBoundingBoxAscent) + Math.abs(metrics.actualBoundingBoxDescent);

        this.canvas.width = width + this.padding;
        this.canvas.height = height + this.padding;
        this.context.font = size + "px serif";
        this.context.textAlign = 'center';
        this.context.textBaseline = 'middle';

        this.context.fillText(char, width/2, height/2);
        this.imageData = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    }
    within(x, y, size) {
        let dx = Math.floor(this.imageData.width * x / size);
        let dy = Math.floor(this.imageData.height * y / size);

        if (this.imageData.data[dy * (this.imageData.width * 4) + dx * 4 + 3])
            return true;
        else
            return false;
    }
}